var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 4v16c0 1.1046.89543 2 2 2h12c1.1046 0 2-.8954 2-2v-11.65838c0-.53822-.2169-1.05373-.6018-1.43001l-4.4403-4.34162c-.3737-.3654-.8755-.56999-1.3982-.56999h-7.5597c-1.10457 0-2 .89543-2 2z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2v4c0 1.10457.8954 2 2 2h4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.fb8334c157b524fe1128e03ef03d47f4.svg";
export { ForwardRef as ReactComponent };